// import React, { useState } from "react";
// import Login from './Login/login';
// import Register from './Register/register';
// import Modal from './Modal/modal';
// import ForgotPassword from "./ForgotPassword/forgotPassword";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// // export default function About({ onLoginSuccess }) {
// export default function About() {

//       const [forgotPassword, setforgotPassword] = useState(false);
    
    
//       const handleClose = () => {
//         setforgotPassword((prev) => !prev);
//       };


//   return (
//     <section className="about section" id="about">

//          <h2 className="section__tittle-1 backcolor0">
//           <span className="backcolor">Lore</span>
//         </h2>

//       <div className="about__container container grid">
//    {/* about__perfil */}

//          {/* <Login handleClose={handleClose} onLoginSuccess={onLoginSuccess} /> */}
//          <Login handleClose={handleClose} />

//     {/* about__info */}

//         <Register />


//         <ToastContainer
//         position="top-center"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop={false}
//         closeOnClick
//         pauseOnHover
//       />


//     {  forgotPassword &&  <Modal header="FORGOT PASSWORD" handleClose={handleClose} content ={<ForgotPassword />} />}

//       </div>
//     </section>
//   );
// }



import React, { useState } from "react";
import Login from './Login/login';
import Register from './Register/register';
import Modal from './Modal/modal';
import ForgotPassword from "./ForgotPassword/forgotPassword";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function About({ onLoginSuccess }) {

  const [forgotPassword, setforgotPassword] = useState(false);

  const handleClose = () => {
    setforgotPassword((prev) => !prev);
  };

  return (

    <section className="about section" id="about">

      <h2 className="section__tittle-1 backcolor0">
        <span className="backcolor">Lore</span>
      </h2>

      <div className="about__container container grid">

        <Login
          handleClose={handleClose}
          onLoginSuccess={onLoginSuccess}
        />

        <Register />

        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnHover
        />

        {
          forgotPassword &&
          <Modal
            header="FORGOT PASSWORD"
            handleClose={handleClose}
            content={<ForgotPassword />}
          />
        }

      </div>

    </section>
  );
}











